import React from "react";
import { Quote } from "lucide-react";

const Stitch = ({ className = "", color = "#E0A526" }) => (
  <svg className={className} viewBox="0 0 100 4" preserveAspectRatio="none">
    <line
      x1="0" y1="2" x2="100" y2="2"
      stroke={color} strokeWidth="2" strokeDasharray="6 5" strokeLinecap="round"
    />
  </svg>
);

const stats = [
  { value: "5,000+", label: "Students Trained" },
  { value: "120+", label: "Villages Reached" },
  { value: "3,200+", label: "Women Empowered" },
  { value: "87%", label: "Placement Rate" },
];

const testimonials = [
  {
    quote: "The tailoring course gave me a trade I could take home. I now stitch for three shops in my village and train two other women myself.",
    name: "Lakshmi R.",
    program: "Tailoring & Fashion Design, 2023",
  },
  {
    quote: "I'd never touched a computer before this course. Six months later I was hired at a local data-entry office.",
    name: "Arun K.",
    program: "Computer Literacy, 2022",
  },
  {
    quote: "The SHG finance training taught our group how to save together and take our first loan. We now run a small poultry business.",
    name: "Selvi M.",
    program: "Entrepreneurship & SHG Finance, 2024",
  },
];

const Impact = () => {
  return (
    <section id="impact" className="py-24 bg-[#082440] text-white scroll-mt-20 relative overflow-hidden">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600;9..144,700&family=IBM+Plex+Sans:wght@400;500;600&family=IBM+Plex+Mono:wght@500&display=swap');
        .mbf-display { font-family: 'Fraunces', serif; }
        .mbf-body { font-family: 'IBM Plex Sans', sans-serif; }
        .mbf-mono { font-family: 'IBM Plex Mono', monospace; }
      `}</style>

      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(0deg, #fff 0 1px, transparent 1px 34px), repeating-linear-gradient(90deg, #fff 0 1px, transparent 1px 34px)",
        }}
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="mbf-mono text-[12px] tracking-[0.18em] uppercase text-[#E0A526]">
            Our Impact
          </span>
          <h2 className="mbf-display mt-4 text-4xl font-semibold leading-tight tracking-tight">
            Numbers Stitched Into Communities
          </h2>
          <Stitch className="w-24 h-2 mx-auto mt-5" color="#E0A526" />
        </div>

        {/* Stat band */}
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/10 border-y border-white/10 mb-20">
          {stats.map(({ value, label }, i) => (
            <div key={i} className="px-4 py-8 text-center">
              <h3 className="mbf-display text-4xl sm:text-5xl font-semibold text-[#E0A526] leading-none">
                {value}
              </h3>
              <p className="mbf-body text-[12.5px] text-blue-100/60 mt-3 uppercase tracking-wide">
                {label}
              </p>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map(({ quote, name, program }, i) => (
            <div
              key={i}
              className="relative bg-white/[0.04] border border-white/10 p-7 hover:bg-white/[0.07] transition-colors duration-300"
            >
              <Quote className="w-6 h-6 text-[#E0A526]/70" />
              <p className="mbf-body mt-4 text-[14.5px] text-blue-100/80 leading-relaxed">
                {quote}
              </p>
              <Stitch className="w-10 h-2 mt-6" color="#E0A526" />
              <p className="mbf-display text-[15px] font-semibold text-white mt-3">
                {name}
              </p>
              <p className="mbf-mono text-[11px] text-blue-100/50 mt-1">
                {program}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Impact;